var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"md":"8","offset-md":"2"}},[_c('v-card',[_c('v-card-title',[_vm._v("New Arrival")]),_c('v-card-text',[_c('arrival-form',{attrs:{"on-success":_vm.onSuccess,"show-terms":false}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }